import React, { useState, useEffect } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import './botLogsAccordion.scss';

interface BotLogsAccordionProps {
  logs: string[];
  isAccordionCollapsed: boolean;
  isStreaming?: boolean;
}

const BotLogsAccordion: React.FC<BotLogsAccordionProps> = ({   logs,   isAccordionCollapsed,   isStreaming = false }) => {
  
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  
  // const filteredLogs = logs?.filter((log) => log?.trim()?.toLowerCase() !== 'done.');

  useEffect(() => {
    if (isAccordionCollapsed && activeIndex === 0) {
      setActiveIndex(null);
    }
  }, [isAccordionCollapsed]);

  if (logs?.length === 0) return null;

  const headerTemplate = () => (
    <div className="accordion-header-content">
      {isStreaming ? (
        <div className="loader-container">
          <div className="custom-spinner" />
          <span className="title">Process Data...</span>
        </div>
      ) : (
        <span className="title">Process finished</span>
      )}
    </div>
  );

  return (
    <div className="bot-logs-accordion">
      <Accordion
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index as number | null)}
        className="custom-accordion"
      >
        <AccordionTab header={headerTemplate()}>
          <div className="logs-container">
            {logs?.map((log, idx) => (
              <div key={idx} className="log-text">
                • {log}
              </div>
            ))}
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default BotLogsAccordion;